import { all, fork, put, select, takeLatest, call } from "redux-saga/effects";
import { REFERENTIELS_SET_PAGINATION } from "../types";
import { modelApiUpsellProvider } from "../../lib/api/providers";
import { MODEL_DELETE, modelSetListLoading } from "../actions/modelActions";
import { tokenSelector } from "../selectors/auth";

const getState = state => state;

const deleteModelApi = (token, id) => {
  return modelApiUpsellProvider.post(
    "/delete",
    { id },
    {
      headers: {
        Authorization: token
      }
    }
  );
};

function* deleteModel({ id }) {
  const state = yield select(getState);
  const modelState = state["models"] || {};
  try {
    const token = yield select(tokenSelector);
    yield put(modelSetListLoading(true));
    yield call(deleteModelApi, token, id);
    yield put({
      type: REFERENTIELS_SET_PAGINATION,
      sectionName: "models",
      page: modelState.page
    });
    //yield put(modelSetListLoading(false));
  } catch (e) {
    console.log(e.message);
    yield put(modelSetListLoading(false));
  }
}

function* watchDeleteModel() {
  yield takeLatest(MODEL_DELETE, deleteModel);
}

export default function* root() {
  yield all([fork(watchDeleteModel)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/modelsSagas.js